
import StoreInfo from "./StoreInfo.vue"
export default {
  comments: {
    StoreInfo
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    dir: {
      type: String,
      default: ""
    },
    storeInfo: {
      type: Object,
      default: () => {}
    },
    services: {
      type: Array,
      default: () => []
    },
    isNearestStore: {
      type: Boolean,
      default: false
    }
  }
}
